module.exports = __webpack_public_path__ + "static/media/attack-number-5.9c1ec6ee.png";